<template>
    <el-dialog title="分配客资" :visible.sync="visible" width="50%" border append-to-body>
        <div class="table_box">
            <div class="row">
                <div class="name">有效客资:</div>
                <div class="info">{{detail.active_amount}}</div>
            </div>
            <div class="row">
                <div class="name">重复客资:</div>
                <div class="info">{{detail.duplicate_amount}}</div>
            </div>
            <div class="tips">点击复选框进行平均分配,余数不等于0的,从上到下依次分配</div>
        </div>

        <!-- 分配客资 -->
        <div v-loading="isLoading" element-loading-text="提交中">
            <div class="allocate-dialog-body">
                <div class="department-tree">
                    <el-tree :data="tree" :props="defaultProps" @node-click="getDepartmentUserList"></el-tree>
                </div>
                <div class="user-list-box">
                    <el-form ref="form" label-width="150px">
                        <el-table height="386" :data="userTableData" ref="userTable"
                            @selection-change="handleUserChange" style="width: 100%">
                            <el-table-column type="selection" width="55"></el-table-column>
                            <el-table-column prop="department" label="部门"></el-table-column>
                            <el-table-column prop="realname" label="真实姓名"></el-table-column>
                            <el-table-column prop="realname" label="客资数">
                                <!-- v-model="ruleForm['number_'+id]" -->
                                <template slot-scope="scope">
                                    <el-input type="text" v-model="scope.row.number"></el-input>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-form>
                </div>
            </div>

            <div class="dialog-footer">
                <el-button @click="visible = false">取 消</el-button>
                <el-button type="primary" :disabled="disabled" v-preventReClick @click="submit">确 定</el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import { preventReClick } from '@/utils/preventReClick';
export default {
    props: {
        parent: {},
    },
    data() {
        return {
            visible: false,
            selectRows: [],
            detail: {
                duplicate_amount: "",
                active_amount: ""
            },
            userTableData: [],
            // 分配客资公司树
            tree: [],
            // tree 默认节点
            defaultProps: {
                children: 'children',
                label: 'label'
            },
            calArr: [],
            disabled: false,
            loading: false,

        }
    },
    computed: {
        isLoading() {
            return this.$store.getters.isLoading;
        }
    },
    methods: {
        showDrawer(row) {
            let _this = this;
            _this.visible = true;
            _this.detail = row;
            _this.disabled = false;
            _this.userTableData = [];
            _this.getDepartmentTree();
            _this.getTree();
        },
        selectsion(rows) {
        },
        //选中table当前行
        handleUserChange(rows) { //选中复选框操作
            let _this = this;
            _this.selectRows = rows;
            let num = _this.selectRows.length;
            let totals = _this.detail.active_amount
            _this.cla(totals, num)

        },
        cla(total, count) {
            let _this = this;
            // _this.selectRows=[];
            _this.calArr = [];
            let base = Math.floor(total / count);
            let rest = total % count;
            for (let i = 0; i < count; i++) {
                _this.calArr.push(base + (i < rest ? 1 : 0))
            }

            _this.userTableData.map((value, index) => {
                value['number'] = '';
                // value['number'] = _this.calArr[index]
            })


            _this.selectRows.map((value, index) => {
                value['number'] = _this.calArr[index]
                // _this.set(_this.selectRows,'number',_this.calArr[index])
            })
        },
        // 获取Tree数据
        getTree() {
            let url = '/api/ucenter.department/getTree';
            let that = this;
            this.$post(url, {}).then(function (response) {
                that.tree = response.data.tree;
            });
        },

        // 获取部门树
        getDepartmentTree() {
            let url = '/api/ucenter.department/getDepartmentTree';
            let that = this;
            this.$post(url, {}).then(function (response) {
                that.departmentTree = response.data.tree;
            });
        },
        // tree 获取部门下的所有员工
        getDepartmentUserList(e) {
            let _this = this;
            _this.form = {};
            let url = '/api/ucenter.user/getDepartmentUserList';
            let query = {
                id: e.id
            };
            // 添加或编辑客资信息
            _this.$post(url, query).then(function (response) {
                if (response.code != '200') {
                    _this.$message.error(response.msg);
                } else {
                    response.data.list.map(ele => {
                        ele.number = '';
                    });

                    _this.userTableData = response.data.list;
                }
            });
        },
        submit() {
            let _this = this;
            _this.disabled = true
            if (_this.selectRows.length == 0) {
                this.$message({
                    message: '请选择要分配的客资',
                    type: 'warning'
                });
                _this.disabled = false
                return false;
            }
            let url = '/api/customer.distribution/doUploadAllocateCustomer';
            let query = {
                id: _this.detail.id,
                users: _this.selectRows
            };
            _this.$store.dispatch('vloading/startLoading')
            // 添加或编辑客资信息
            _this.$post(url, query).then(function (response) {
                if (response.code == '200') {
                    _this.$message({
                        message: response.msg,
                        type: 'success'
                    });
                    _this.visible = false;
                    _this.parent.getTableData();
                    _this.disabled = true;
                    _this.$store.dispatch('vloading/stopLoading')
                } else {
                    _this.$store.dispatch('vloading/stopLoading')
                    _this.disabled = false
                    _this.$message.error(response.msg);
                }

            });
        }
    }
}
</script>

<style lang="less" scoped>
.table_box {
    margin-bottom: 10px;

    .tips {
        margin-top: 15px;
        color: #eb5e0b;
    }

    .row {
        display: flex;
        height: 35px;
        line-height: 35px;
        border-bottom: #ddd solid 1px;

        .name {
            width: 80px;
        }

        .info {
            flex: 1;
        }
    }
}
.dialog-footer {
    text-align: right;
}
.allocate-dialog-body {
    .user-list-box {
        padding: 0;
    }
}
</style>